<template>
  <card-wrapper>
    <v-form v-model="valid" @submit.prevent="submit">
      <v-row>
        <v-col cols="12" md="4">
          <input-digits
            v-model="supplierCode"
            :label="$t('page.consultation.filters.supplierFields.code')"
            clearable
            :disabled="!!supplierCorpName"
          />
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field
            v-model="supplierCorpName"
            :label="$t('page.consultation.filters.supplierFields.name')"
            clearable
            :disabled="!!supplierCode"
          />
        </v-col>
        <v-col cols="12" md="4" align-self="center" class="text-left">
          <v-btn type="submit" block class="mt-3" color="primary" large :loading="loading" :disabled="submitDisabled">
            {{ $t('page.selection.searchButton') }}
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
  </card-wrapper>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue';
import CardWrapper from '@/components/interface/card-wrapper.vue';
import InputDigits from '@/components/interface/input-digits.vue';

export default Vue.extend({
  name: 'SupplierSearchForm',
  components: {
    CardWrapper,
    InputDigits
  },
  props: {
    search: {
      type: Function as PropType<(supplierCode?: number, supplierCorpName?: string) => void>,
      default: () => () => {}
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      valid: true,
      supplierCode: undefined as number | undefined,
      supplierCorpName: ''
    };
  },
  computed: {
    submitDisabled(): boolean {
      return !this.supplierCode && !this.supplierCorpName;
    }
  },
  methods: {
    submit(): void {
      this.search(this.supplierCode, this.supplierCorpName);
    }
  }
});
</script>
